import React from "react";
import { DIAS_SEMANA, TURNOS_HORARIO } from "../../utils/horariosAtencion";

const crearFechaHastaMinutos = (minutos) => {
  const fecha = new Date();
  fecha.setMinutes(fecha.getMinutes() + minutos);
  return fecha.toISOString();
};

const crearFechaRestoDelDia = () => {
  const fecha = new Date();
  fecha.setHours(23, 59, 59, 999);
  return fecha.toISOString();
};

const formatearFecha = (iso) => {
  if (!iso) return "";

  try {
    return new Date(iso).toLocaleString("es-MX", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  } catch {
    return "";
  }
};

function AdminHorariosAtencion({ horariosAtencion, setHorariosAtencion }) {
  const actualizarDia = (turnoId, diaId, campo, valor) => {
    setHorariosAtencion((prev) => ({
      ...prev,
      turnos: {
        ...prev.turnos,
        [turnoId]: {
          ...prev.turnos[turnoId],
          [diaId]: {
            ...prev.turnos[turnoId][diaId],
            [campo]: valor,
          },
        },
      },
    }));
  };

  const actualizarMensajeCerrado = (valor) => {
    setHorariosAtencion((prev) => ({
      ...prev,
      mensajeCerrado: valor,
    }));
  };

  const actualizarMensajeSuspension = (valor) => {
    setHorariosAtencion((prev) => ({
      ...prev,
      suspension: {
        ...prev.suspension,
        mensaje: valor,
      },
    }));
  };

  const copiarDiaATodos = (turnoId, diaId) => {
    const diaOrigen = horariosAtencion.turnos[turnoId][diaId];

    setHorariosAtencion((prev) => {
      const turnoNuevo = {};

      DIAS_SEMANA.forEach((dia) => {
        turnoNuevo[dia.id] = {
          ...diaOrigen,
        };
      });

      return {
        ...prev,
        turnos: {
          ...prev.turnos,
          [turnoId]: turnoNuevo,
        },
      };
    });
  };

  const activarSuspension = ({ tipo, hasta }) => {
    setHorariosAtencion((prev) => ({
      ...prev,
      suspension: {
        ...prev.suspension,
        activa: true,
        tipo,
        hasta: hasta || null,
      },
    }));
  };

  const reactivarTienda = () => {
    setHorariosAtencion((prev) => ({
      ...prev,
      suspension: {
        activa: false,
        tipo: "ninguna",
        hasta: null,
        mensaje: "",
      },
    }));
  };

  const suspensionActiva = horariosAtencion?.suspension?.activa;
  const suspensionHasta = horariosAtencion?.suspension?.hasta;

  return (
    <div style={sectionBoxStyle}>
      <h3 style={sectionTitleStyle}>⏰ Horarios de atención</h3>

      <p style={sectionHelpStyle}>
        Configura por día hasta qué hora se reciben pedidos. Los campos empiezan
        vacíos hasta que tú los captures desde admin.
      </p>

      <div
        style={{
          backgroundColor: "#fff8e1",
          border: "1px solid #ffe0a3",
          borderRadius: "14px",
          padding: "14px",
          marginBottom: "16px",
        }}
      >
        <h4 style={{ margin: "0 0 8px 0", fontSize: "15px", fontWeight: 900 }}>
          Regla operativa
        </h4>

        <p
          style={{
            margin: 0,
            fontSize: "13px",
            color: "#7a4b00",
            lineHeight: "1.5",
            fontWeight: 700,
          }}
        >
          Captura la hora real en que dejarás de recibir pedidos. Por ejemplo:
          si el restaurante cierra a las 23:00, puedes cerrar pedidos a las
          22:00 para tener margen de preparación y repartidor.
        </p>
      </div>

      {TURNOS_HORARIO.map((turno) => (
        <div key={turno.id} style={turnoBoxStyle}>
          <h4 style={turnoTitleStyle}>{turno.label}</h4>

          <div style={{ display: "grid", gap: "10px" }}>
            {DIAS_SEMANA.map((dia) => {
              const configDia = horariosAtencion.turnos[turno.id][dia.id];

              return (
                <div key={dia.id} style={diaRowStyle}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "13px",
                      fontWeight: "900",
                      color: "#111",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={configDia.activo}
                      onChange={(e) =>
                        actualizarDia(
                          turno.id,
                          dia.id,
                          "activo",
                          e.target.checked,
                        )
                      }
                    />
                    {dia.label}
                  </label>

                  <div>
                    <label style={miniLabelStyle}>Abre pedidos</label>
                    <input
                      type="time"
                      value={configDia.apertura}
                      onChange={(e) =>
                        actualizarDia(
                          turno.id,
                          dia.id,
                          "apertura",
                          e.target.value,
                        )
                      }
                      disabled={!configDia.activo}
                      style={inputStyle}
                    />
                  </div>

                  <div>
                    <label style={miniLabelStyle}>Cierra pedidos</label>
                    <input
                      type="time"
                      value={configDia.cierrePedidos}
                      onChange={(e) =>
                        actualizarDia(
                          turno.id,
                          dia.id,
                          "cierrePedidos",
                          e.target.value,
                        )
                      }
                      disabled={!configDia.activo}
                      style={inputStyle}
                    />
                  </div>

                  <button
                    type="button"
                    onClick={() => copiarDiaATodos(turno.id, dia.id)}
                    style={copyButtonStyle}
                  >
                    Copiar a todos
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      <div style={sectionBoxInnerStyle}>
        <h4 style={turnoTitleStyle}>🚦 Suspensión temporal de tienda</h4>

        <p style={sectionHelpStyle}>
          Úsalo si hay demasiados pedidos, si no hay repartidor, si se fue la
          luz o si necesitas pausar la tienda sin borrar horarios.
        </p>

        {suspensionActiva ? (
          <div
            style={{
              backgroundColor: "#fff4f4",
              border: "1px solid #ffcdd2",
              borderRadius: "12px",
              padding: "12px",
              marginBottom: "12px",
              color: "#8b0000",
              fontSize: "13px",
              fontWeight: "800",
              lineHeight: "1.5",
            }}
          >
            Tienda suspendida actualmente.
            {suspensionHasta ? (
              <>
                <br />
                Reactivación estimada: {formatearFecha(suspensionHasta)}
              </>
            ) : (
              <>
                <br />
                Permanecerá suspendida hasta que la reactives manualmente.
              </>
            )}
          </div>
        ) : (
          <div
            style={{
              backgroundColor: "#e8f5e9",
              border: "1px solid #c8e6c9",
              borderRadius: "12px",
              padding: "12px",
              marginBottom: "12px",
              color: "#1b5e20",
              fontSize: "13px",
              fontWeight: "800",
            }}
          >
            Tienda activa normalmente.
          </div>
        )}

        <div style={{ marginBottom: "12px" }}>
          <label style={miniLabelStyle}>Mensaje de suspensión</label>

          <textarea
            value={horariosAtencion.suspension?.mensaje || ""}
            onChange={(e) => actualizarMensajeSuspension(e.target.value)}
            rows={2}
            placeholder="Ej. Estamos saturados por el momento. Volvemos en unos minutos."
            style={{
              ...inputStyle,
              resize: "vertical",
            }}
          />
        </div>

        <div style={suspensionGridStyle}>
          <button
            type="button"
            onClick={() =>
              activarSuspension({
                tipo: "30_min",
                hasta: crearFechaHastaMinutos(30),
              })
            }
            style={pauseButtonStyle}
          >
            ⏸️ 30 min
          </button>

          <button
            type="button"
            onClick={() =>
              activarSuspension({
                tipo: "1_hora",
                hasta: crearFechaHastaMinutos(60),
              })
            }
            style={pauseButtonStyle}
          >
            ⏸️ 1 hora
          </button>

          <button
            type="button"
            onClick={() =>
              activarSuspension({
                tipo: "2_horas",
                hasta: crearFechaHastaMinutos(120),
              })
            }
            style={pauseButtonStyle}
          >
            ⏸️ 2 horas
          </button>

          <button
            type="button"
            onClick={() =>
              activarSuspension({
                tipo: "resto_dia",
                hasta: crearFechaRestoDelDia(),
              })
            }
            style={pauseButtonStyle}
          >
            🌙 Resto del día
          </button>

          <button
            type="button"
            onClick={() =>
              activarSuspension({
                tipo: "manual",
                hasta: null,
              })
            }
            style={dangerButtonStyle}
          >
            🚫 Hasta reactivar
          </button>

          <button
            type="button"
            onClick={reactivarTienda}
            style={activeButtonStyle}
          >
            ✅ Reactivar
          </button>
        </div>
      </div>

      <div style={{ marginTop: "14px" }}>
        <label style={miniLabelStyle}>
          Mensaje general cuando esté cerrado
        </label>

        <textarea
          value={horariosAtencion.mensajeCerrado || ""}
          onChange={(e) => actualizarMensajeCerrado(e.target.value)}
          rows={3}
          placeholder="Ej. Por ahora la tienda está cerrada. Puedes revisar el menú y volver en nuestro horario de atención."
          style={{
            ...inputStyle,
            resize: "vertical",
          }}
        />
      </div>
    </div>
  );
}

const sectionBoxStyle = {
  backgroundColor: "#fafafa",
  border: "1px solid #eee",
  borderRadius: "16px",
  padding: "16px",
};

const sectionBoxInnerStyle = {
  backgroundColor: "#fff",
  border: "1px solid #eee",
  borderRadius: "14px",
  padding: "14px",
  marginTop: "16px",
};

const sectionTitleStyle = {
  margin: "0 0 6px 0",
  fontSize: "18px",
  fontWeight: "900",
};

const sectionHelpStyle = {
  margin: "0 0 14px 0",
  fontSize: "13px",
  color: "#666",
  lineHeight: "1.5",
};

const turnoBoxStyle = {
  backgroundColor: "#fff",
  border: "1px solid #eee",
  borderRadius: "14px",
  padding: "14px",
  marginBottom: "14px",
};

const turnoTitleStyle = {
  margin: "0 0 12px 0",
  fontSize: "15px",
  fontWeight: "900",
};

const diaRowStyle = {
  display: "grid",
  gridTemplateColumns: "150px 1fr 1fr 120px",
  gap: "10px",
  alignItems: "end",
  borderBottom: "1px solid #f1f1f1",
  paddingBottom: "10px",
};

const miniLabelStyle = {
  display: "block",
  fontSize: "12px",
  fontWeight: "800",
  marginBottom: "5px",
  color: "#333",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "10px",
  border: "1px solid #ddd",
  fontSize: "13px",
  boxSizing: "border-box",
};

const copyButtonStyle = {
  backgroundColor: "#eee",
  color: "#111",
  border: "none",
  borderRadius: "10px",
  padding: "10px",
  fontSize: "12px",
  fontWeight: "800",
  cursor: "pointer",
};

const suspensionGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
  gap: "8px",
};

const pauseButtonStyle = {
  backgroundColor: "#fff8e1",
  color: "#7a4b00",
  border: "1px solid #ffe0a3",
  borderRadius: "10px",
  padding: "10px",
  fontSize: "12px",
  fontWeight: "900",
  cursor: "pointer",
};

const dangerButtonStyle = {
  backgroundColor: "#fff4f4",
  color: "#b00020",
  border: "1px solid #ffcdd2",
  borderRadius: "10px",
  padding: "10px",
  fontSize: "12px",
  fontWeight: "900",
  cursor: "pointer",
};

const activeButtonStyle = {
  backgroundColor: "#e8f5e9",
  color: "#1b5e20",
  border: "1px solid #c8e6c9",
  borderRadius: "10px",
  padding: "10px",
  fontSize: "12px",
  fontWeight: "900",
  cursor: "pointer",
};

export default AdminHorariosAtencion;
